import React from 'react';
import styled from 'styled-components';
import { useSkin } from '../styles/skins';

const SwitcherContainer = styled.div`
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  display: flex;
  gap: 0.5rem;
  z-index: 1000;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.5rem;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
`;

const SkinButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  background-color: ${({ active }) => active ? '#4a90e2' : '#f5f5f5'};
  color: ${({ active }) => active ? 'white' : 'black'};
  cursor: pointer;
  
  &:hover {
    background-color: ${({ active }) => active ? '#3a80d2' : '#e5e5e5'};
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.5);
  }
`;

const ThemeSwitcher = () => {
  const { currentSkin, setSkin, availableSkins } = useSkin();
  
  return (
    <SwitcherContainer>
      {availableSkins.map(skin => (
        <SkinButton
          key={skin}
          active={currentSkin === skin}
          onClick={() => setSkin(skin)}
        >
          {skin.charAt(0).toUpperCase() + skin.slice(1)}
        </SkinButton>
      ))}
    </SwitcherContainer>
  );
};

export default ThemeSwitcher;

